import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Modal from './components/Common/Modal';
import ButtonLoader from './components/Common/ButtonLoader';
import Loader from './components/Common/Loader';
import { isMobile } from 'mobile-device-detect';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import Notifications from 'vue-notification';
import i18n from "./plugins/i18n";
import 'swiper/dist/css/swiper.css';
import './assets/scss/app.scss';
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueCookies from 'vue-cookies'
import VueMeta from 'vue-meta'
import VueMoment from 'vue-moment'
import Paginate from 'vuejs-paginate'
import JsonViewer from 'vue-json-viewer'
import 'vue-json-viewer/style.css'
import { ENV_API_URL } from './plugins/replaces'
import VueHtmlJs from 'vue-html-js';
import './registerServiceWorker'

if(window.location !== window.parent.location){
  window.parent.location.reload()
}


import { io } from 'socket.io-client';

if (typeof window !== 'undefined') {
    window.io = io;
}
window._ = require("lodash");

Vue.component('Modal', Modal);
Vue.component('Loader', Loader);
Vue.component('ButtonLoader', ButtonLoader);
Vue.component('paginate', Paginate)

i18n.locale = store.getters['language/getLanguage'];

window.axios = require('axios');
window.axios.defaults.baseURL = ENV_API_URL;
window.axios.defaults.headers.common = {
  'Language': i18n.locale,
  'Accept': 'application/json',
  'Authorization': 'Bearer ' +  store.getters['auth/token'],
  'Client': process.env.VUE_APP_CLIENT_NAME
};

window.axios.interceptors.response.use((response) => {
  return response
},
function (error) {
  if (error.response.status === 401) {
    store.dispatch('alert/alert', { type: 'error', title: error.response.data.message})
    store.dispatch('auth/logout', { silent: true })
  } else if (error.response.status === 422 || error.response.status === 429 || error.response.status === 403) {
    if(!_.isUndefined(error.response.data.validation_required) && error.response.data.validation_required) {
      router.push({ name: 'User', params: { section: 'security', payment: null } })
    }
    store.dispatch('alert/alert', { type: 'error', errors: error.response.data.errors, rules: error.response.data.rules, request: error.response.data.request, title: error.response.data.message });
  } else{
    store.dispatch('alert/alert', { type: 'error', title: 'whoops' });
  }
  return Promise.reject(error);
});

Vue.use(JsonViewer)

Vue.use(VueAwesomeSwiper);
Vue.use(Notifications);
Vue.use(VueCookies);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});
Vue.use(VueMeta);
Vue.use(VueMoment);
Vue.use(VueReCaptcha, { 
  siteKey: process.env.VUE_APP_RECAPTCHA_KEY,
  loaderOptions: {
    useRecaptchaNet: true,
    autoHideBadge: true
  }
});
Vue.use(VueHtmlJs);

if(process.env.NODE_ENV == 'development'){
  Vue.config.devtools = true;
}


Vue.filter("currency", function(value) {
  var v = parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  return parseFloat(value) !== +value ? 0 : v;
});

Vue.filter('toDouble', function (value) {
    value = parseFloat(value).toFixed(2);
    return isNaN(value) ? 0 : value;
});

Vue.filter('ucFirst', function (value) {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
});

Vue.filter('truncate', function (value, letter) {
    if (value.length > letter) {
        value = value.substring(0, letter - 3) + '...';
    }
    return value;
});
Vue.filter('toInt', function (value) {
    value = parseInt(value)
    return isNaN(value) ? 0 : value;
});

Vue.filter('toHours', function (value) {
  return String(Math.floor( value / 3600)).padStart(2, '0');
});

Vue.filter('toMinutes', function (value) {
  return String(Math.floor( value / 60 % 60)).padStart(2, '0');
});

Vue.filter('toSeconds', function (value) {
  return String(Math.floor( value % 60)).padStart(2, '0');
});

Vue.prototype._ = window._;
Vue.prototype.isMobile = isMobile;
Vue.prototype.$user = function() {
    return store.getters['auth/user'];
}
Vue.prototype.$user_detail = function() {
    return store.getters['auth/user_detail'];
}
Vue.prototype.$auth = function() {
  return store.getters['auth/isLoggedIn'];
}
Vue.prototype.$pageMeta = function($meta) {
  return _.get(store.getters['getClientMeta'], 'pages.' + $meta);
}
Vue.prototype.$odds = function() {
    return store.getters['translate/odds'];
}

Vue.prototype.$getOddName = function(prefix) {
  var odd  = _.find(this.$odds, function(o) { return o.prefix == prefix})
  
  if(!_.isUndefined(odd) && !_.isEmpty(odd) && !_.isUndefined(odd.tr))
  {
    return odd.tr;
  }

  return prefix;
}
Vue.prototype.$getMarketName = function(market_id, type = 'live', event, markets) {
  
  var sport_id = event;
  var market   = _.find(markets, function(o) { return o.market_id == market_id && o.sport_id == sport_id})

  if(!_.isUndefined(market) && !_.isEmpty(market) && !_.isUndefined(market.tr))
  {
    return market.tr;
  }

  return market_id;
}
Vue.prototype.$getOddName = function(prefix,translateOdds) {
  var odd  = _.find(translateOdds, function(o) { return o.prefix == prefix})
  
  if(!_.isUndefined(odd) && !_.isEmpty(odd) && !_.isUndefined(odd.tr))
  {
    return odd.tr;
  }

  return prefix;
}

new Vue({
  router,
  store,
  i18n,
  duplicateNavigationPolicy: 'ignore',
  render: function (h) { return h(App); },
  mounted () 
  {
    store.dispatch('auth/user');
    setInterval(()=>{
      store.dispatch('auth/user');
    }, 60000);

    /* AFFILIATE */
    if(this.$route.query.l_id && this.$route.query.l_id > 0 && this.$route.query.a_id && this.$route.query.a_id > 0)
    {
      store.dispatch('cookie/setAffiliate', {
        l_id: this.$route.query.l_id,
        a_id: this.$route.query.a_id,
      });
    }
    
    store.dispatch('socket/initChannels');

    //store.dispatch('live/fetchEvent', '02H71X32010064');
    // store.dispatch('translate/fetchSports');
    // store.dispatch('translate/fetchMarkets');
    // store.dispatch('translate/fetchOdds');
    // store.dispatch('live/fetchFullData');
    // store.dispatch('fsocket/initChannels');
    /* AFFILIATE */
  }
}).$mount('#app');


